import { render, staticRenderFns } from "./RightsFundLog.vue?vue&type=template&id=79aa1e56"
import script from "./RightsFundLog.vue?vue&type=script&lang=js"
export * from "./RightsFundLog.vue?vue&type=script&lang=js"
import style0 from "./RightsFundLog.vue?vue&type=style&index=0&id=79aa1e56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports